module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-azure-016-1200x2490.a269cf04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-azure-016-1200x2490.jpg
// module id = 1087
// module chunks = 37